import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

const Item = ({ label, value }) => {
  return (
    <>
      <Typography gutterBottom variant="caption">
        {label}
      </Typography>
      <Box sx={{ mb: 2, typography: 'body1bold' }}>{value}</Box>
    </>
  );
};

Item.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.node,
};
Item.defaultProps = {
  value: undefined,
};

export default Item;
